module.exports = __webpack_public_path__ + "img/2017.d9bdc40c.webp";